module.exports = __webpack_public_path__ + "img/icon-breadcrumb.d60ae1e2.png";